let items = document.querySelectorAll(".header__inline-menu details");
let currentSelectedItem = null;

const closeOthers = (selectedItem) => {
  items.forEach((item) => {
    if (item !== selectedItem) {
      item.removeAttribute("open");
    }
  });
};

items.forEach((item) => {
  const handleMouseEnter = () => {
    item.setAttribute("open", true);
    currentSelectedItem = item;
    closeOthers(currentSelectedItem);
  };
  const handleMouseLeave = () => {
    item.removeAttribute("open");
    currentSelectedItem = null;
  };
  const handleFocus = () => {
    item.setAttribute("open", true);
    currentSelectedItem = item;
    closeOthers(currentSelectedItem);
  };
  const handleBlur = () => {
    item.removeAttribute("open");
    currentSelectedItem = null;
  };
  const itemMegaMenu = item.querySelector(".mega-menu__content");

  // item.addEventListener("mouseenter", handleMouseEnter);
  // itemMegaMenu.addEventListener("mouseleave", handleMouseLeave);
  item.addEventListener("focus", handleFocus);
  itemMegaMenu.addEventListener("blur", handleBlur);
});
